
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
export default {
  props: {
    app: {},
    isSubscribed: {
      default: false
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters("apps", ["getMyApps"])
    // isSubscribed() {
    //   return this.getMyApps.find(app => {
    //     return app.identifier == this.app.identifier;
    //   });
    // }
  },
  methods: {
    ...mapActions("apps", ["subscribeApp", "unSubscribeApp"]),
    handleClick() {
      if (this.isSubscribed) {
        this.handleUnSubscribeApp();
      } else {
        this.handleSubscribeApp();
      }
    },
    handleSubscribeApp() {
      this.loading = true;
      this.subscribeApp(this.app.id)
        .then((response) => {
          this.$nuxt.$emit("show-toast", {
            text: response.data.messages || response.data.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleUnSubscribeApp() {
      this.unSubscribeApp(this.app.id)
        .then((response) => {
          this.$nuxt.$emit("show-toast", {
            text: response.data.messages || response.data.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
